import { mediaHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

interface FixedSelectProps {
  width: string;
  maxWidth: string;
}

const Wrapper = styled.div<{ $width: string; $maxWidth: string }>`
  ${({ $width, $maxWidth }) => {
    return css`
      [role='listbox'] {
        position: fixed;
        width: ${$width};
        max-width: ${$maxWidth};

        ${mediaHelper('mobile')} {
          position: unset;
          width: unset;
          max-width: unset;
        }
      }
    `;
  }}
`;

export const SelectWithFixedPositionOptions: FunctionComponent<
  PropsWithChildren<FixedSelectProps>
> = ({ children, width, maxWidth }) => {
  return (
    <Wrapper $width={width} $maxWidth={maxWidth}>
      {children}
    </Wrapper>
  );
};
